import { useContext, useState } from 'preact/hooks';
import { SessionContext } from '../app.jsx';
import { post } from '../api.js';
import { Field, useForm } from '../ui/Field.jsx';

// The signed-out frame: the wordmark on the forest band, the form below.
// On the sign-in screen the wordmark is the page's heading; elsewhere the form has its own.
export function Entry({ children, brandIsHeading = false }) {
  const Brand = brandIsHeading ? 'h1' : 'p';
  return (
    <div class="entry">
      <div class="entry-band"><Brand class="wordmark wordmark-large">Wild Serbia</Brand></div>
      <main class="entry-body">{children}</main>
    </div>
  );
}

export function Login() {
  const { refresh } = useContext(SessionContext);
  const [f, bind] = useForm({ username: '', password: '' });
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await post('/login', { username: f.username, password: f.password });
      await refresh();
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <Entry brandIsHeading>
      <form class="stack-form" onSubmit={submit}>
        <Field label="Korisničko ime">
          <input {...bind('username')} autocomplete="username" autocapitalize="none" spellcheck={false} required />
        </Field>
        <Field label="Lozinka">
          <input {...bind('password')} type="password" autocomplete="current-password" required />
        </Field>
        {error && <p class="alert" role="alert">{error}</p>}
        <button class="btn" disabled={busy}>Uđi</button>
      </form>
    </Entry>
  );
}
